import React from "react";
import { Redirect } from "react-router-dom";
import Login from "../components/Login";
import Logout from "../components/Logout";
import SessionExpired from "../components/SessionExpired";
import ForgetPwd from "../components/Authentication/ForgetPassword";
import PasswordResetPage from "../components/Authentication/PasswordResetPage";
import Users from "../components/Users";
import AccessDeniedPage from "../components/AccessDenied";
import Organization from "../CloudCatcher/Organization/Organization";
import globalLicenseAndAddOns from "../GlobalLicenseManagement/globalLicenseAndAddOns";
import OrganizationAccount from "../CloudCatcher/Organization/account/OrganizationAccount";
import OrganizationBilling from "../CloudCatcher/Organization/billing/OrganizationBilling";
import OrganizationIaac from "../CloudCatcher/Organization/iaac/OrganizationIaac";
import LandingPage from "../components/LandingPage";
import CustomLicenseManager from "../CustomLicenseManagement/CustomLicenseManager";
import GlobalIaaCManager from "../GlobalLicenseManagement/GlobalIaaCManager";
import MalwareScan from "../CloudCatcher/MalwareScan/MalwareScan";

const authProtectedRoutes = [
  { path: "/details", component: LandingPage },
  { path: "/organization/account/:orgCode", component: OrganizationAccount },
  { path: "/organization/billing/:orgCode", component: OrganizationBilling },
  { path: "/organization/iaac/:orgCode", component: OrganizationIaac },
  {
    path: "/organization/customlicensemanager/:orgCode",
    component: CustomLicenseManager,
  },
  { path: "/organization", component: Organization },
  { path: "/malwarescan", component: MalwareScan },
  { path: "/globallicensemanager", component: globalLicenseAndAddOns },
  { path: "/globaliaacmanager", component: GlobalIaaCManager },
];

const adminRoute = [{ path: "/users", component: Users }];

const publicRoutes = [
  { path: "/sessionExpired", component: SessionExpired },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/reset-password", component: PasswordResetPage },
  { path: "/login", component: Login },
  { path: "/logout", component: Logout },
  { path: "/access-denied", component: AccessDeniedPage},
  { path: "/", component: () => <Redirect to="/login" /> },
];

export { publicRoutes, authProtectedRoutes, adminRoute };